import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "EDIT_COLOR_VARIABLE", {
  EDIT: "Color variable edited succesfully",
});
